import { Dispatch } from 'react';
import { PayloadAction } from 'typesafe-actions';
import { createContext } from 'use-context-selector';
import { HeaderState, HeaderActionTypes } from './types';
import { defaultHeaderState } from './defaultState';

const HeaderContext = createContext<HeaderState>(defaultHeaderState);
const HeaderDispatchContext = createContext<Dispatch<PayloadAction<HeaderActionTypes, any>> | undefined>(undefined);

export { HeaderContext, HeaderDispatchContext };
